import React from 'react'
import { observable, action } from 'mobx'
import { BaseManipStateFn, BaseTableState } from './base'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import Validators from './validators'

export default (store) => {
  class ManipState extends BaseManipStateFn(store) {
    @action owncontractsLoad (data) {
      this.owncontracts = data
    }

    @action clientpaymentsLoad (data) {
      this.clientpayments = data
    }

    onLoaded (entity) {
      // list of contracts
      store.requester.call(`/contracts/ownedby/${entity.id}`)
        .then(({ data }) => {
          const owncontracts = store.options.has('contracts') && store.options.get('contracts').filter(c => {
            return data.includes(c.id)
          })
          this.owncontractsLoad(owncontracts)
        })
        .catch(store.onRequesterError.bind(store))

      // list of payments
      store.requester.call(`/contracts/payments/${entity.id}`)
        .then(({ data }) => {
          this.clientpaymentsLoad(data)
        })
        .catch(store.onRequesterError.bind(store))

      // create title for edit view
      try {
        this.edittitle = (
          <span>
            {store.__(linkConst.LINK_CLIENTS_TITLE).concat(defaultConst.TITLE_DIVIDER)}
            <span className='text-primary text-strong'> {entity && entity.name} </span>
            {defaultConst.TITLE_DIVIDER}
            {store.__(defaultConst.TITLE_EDIT)}
          </span>)
      } catch (e) {
        // no title
      }

      super.onLoaded(entity)
    }

    beforeSave (entity) {
      // trim all necesary values
      entity.name = entity.name ? entity.name.trim() : null
      super.beforeSave(entity)
    }

    onSaved (saved) {
      super.onSaved(saved)
      store.markDirty(linkConst.LINK_CLIENTS)
    }

    requiredOptions = [
      'ClientsType',
      'ContractTypes',
      linkConst.LOAD_OPTIONS.contracts,
      linkConst.LOAD_OPTIONS.clients,
      linkConst.LOAD_OPTIONS.constantsList
    ]

    createtitle = store.__(linkConst.LINK_CLIENTS_TITLE).concat(defaultConst.TITLE_DIVIDER) + store.__(defaultConst.TITLE_CREATE)
    edittitle = store.__(linkConst.LINK_CLIENTS_TITLE).concat(defaultConst.TITLE_DIVIDER)

    @observable owncontracts = []
    @observable clientpayments = []

    subentities = {
      financial_reports: store.createEmbededEntityState({
        attrs: [
          'id',
          'preview',
          'contract_id',
          'month',
          'year'
        ],
        titles: [
          store.__('ID'),
          store.__('report'),
          store.__('contract'),
          store.__('month'),
          store.__('year')
        ],
        _sortField: 'id',
        noSort: ['preview'],
        validators: {
        }
      }),

      owncontracts: store.createEmbededEntityState({
        attrs: [
          'id', 'name', 'contract_type', 'contract_date', 'contract_end_date'
        ],
        titles: [
          store.__('ID'),
          store.__('name'),
          store.__('contract type'),
          store.__('begin date'),
          store.__('end date')
        ],
        _sortField: 'id'
      }),

      clientpayments: store.createEmbededEntityState({
        attrs: [
          'id', 'contract_id', 'month', 'year', 'status', 'amount_to_be_paid', 'amount_to_be_paid_calculated', 'wire_fee',
          'withholding_tax_amount', 'pay_date', 'amount_paid', 'amount_paid_including_vat', 'invoice_number', 'dwh_last_updated_at'
        ],
        titles: [
          store.__('id'), store.__('contract'), store.__('month'), store.__('year'), store.__('status'), store.__('amount payable'), store.__('amount payable calculated'), store.__('wire fee'),
          store.__('withholding tax'), store.__('pay date'), store.__('transfer amount'), store.__('transfer amount (incl. VAT)'), store.__('invoice number'), store.__('DWH last update')
        ],
        _sortField: 'year,month,id',
        _sortDir: 'DESC,DESC,DESC',
        noSort: ['amount_to_be_paid_calculated']
      })
    }

    validators = {
      name: [
        Validators.isMandatory(store),
        Validators.maxLength(store, 128)
      ],
      taxid: [
        Validators.maxLength(store, 64)
      ],
      address: [
        Validators.isMandatory(store),
        Validators.maxLength(store, 255)
      ],
      contact: [
        Validators.maxLength(store, 255)
      ],
      client_type: [
        Validators.isMandatory(store)
      ]
    }
  }

  class TableState extends BaseTableState {
    attrs = [
      'id', 'name', 'taxid', 'address', 'contact', 'withholding_tax', 'client_type'
    ]

    headertitles = [
      store.__('ID'), store.__('name'), store.__('tax ID'),
      store.__('address'), store.__('contact'), store.__('withholding tax (%)'), store.__('Client type')
    ]

    defaultSort = linkConst.DEFAULT_SORT[linkConst.LINK_CLIENTS]
    title = store.__(linkConst.LINK_CLIENTS_TITLE)

    requiredOptions = [
      'ClientsType'
    ]
  }

  return { ManipState, TableState }
}
